function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5424 4.47126C18.1301 3.92519 18.1526 3.01786 17.5927 2.44468C17.0328 1.87151 16.1025 1.84953 15.5148 2.3956C15.5148 2.3956 6.44563 10.953 6.42089 10.9778C5.84131 11.5692 5.86299 12.5068 6.46931 13.072L15.5147 21.6027C16.1014 22.1498 17.0318 22.1293 17.5927 21.5571C18.1536 20.9848 18.1326 20.0774 17.5458 19.5304L9.90828 12.2029C9.79343 12.0927 9.7934 11.909 9.90823 11.7988L17.5424 4.47126Z",
  fill: "#878793"
});

function SvgIconKeyboardArrowLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKeyboardArrowLeft);
export default __webpack_public_path__ + "static/media/icon-keyboard-arrow-left.d332fc32.svg";
export { ForwardRef as ReactComponent };